import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/services/login/login.service';
import { SweetServices } from 'src/services/sweet.services';
import { AppComponent } from '../../app.component';
import { HomeService } from 'src/services/home/home.service';
import { Helper } from 'src/app/common/Helper/Helper';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})

export class ResetPassComponent implements OnInit {
  selectedLanguage = environment.lang;
  public lang: string = environment.lang;
  public traduccion = environment.traduccion;

  public appdata:any;
  env:string;
  backgroundStyle: any = {};
  constructor(
    private alerta: SweetServices,
    private appLoading: AppComponent,
    private loginService: LoginService,
    private router: Router,
    private homeService: HomeService,
    private Helpers: Helper
  ) {
    this.appdata = this.homeService.getEnvironment();
    this.env = this.appdata.licenseData.customer.isProduction
      ? '' 
      : this.appdata.licenseData.customer.customerName + ' ' + this.appdata.licenseData.customer.environment;
    this.updateBackgroundStyle();
  }

  //Se mantiene de momento
  ngOnInit() {
  }

  resetpassForm = {
    Login: '',
    Password: '',
    Bloqueo: false,
    version: environment.version
  };

  //Validar en un futuro quitar formResetpass
  submitResetpass(formResetpass: NgForm) {
    this.appLoading.loading = true;
    if (this.resetpassForm.Login === '') {
      this.appLoading.loading = false;
      this.alerta.AlertaErrorTimer('Llena el Formulario');
    } else {
      this.loginService.emailRestablecerPassword(this.resetpassForm).subscribe(response => {
        if (response === null) {
          this.appLoading.loading = false;
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        } else if (response.isCorrect === 'false') {
          this.appLoading.loading = false;
          this.alerta.AlertaError(response.message);
        } else {
          this.correctResetpass();
        }
      }, (err) => {
        this.appLoading.loading = false;
        this.alerta.AlertaCatch(err);
      }
      );
    }
  }

  private correctResetpass() {
    this.appLoading.loading = false;
    this.alerta.AlertaSuccessTimer(
      "Se ha enviado un correo para procesar su solicitud de cambio de contraseña.");
    this.goLogin();
  }

  goLogin() {
    this.router.navigate(['/', 'login']);
  }

  public cancelar() {
    this.goLogin();
  }

  updateBackgroundStyle() {
    this.backgroundStyle = this.Helpers.updateBackgroundStyle(this.env);
  };
}
